import $ from 'jquery';

export default () => {
    const slider = $('.js-events-slider');
    const toggleAll = $('.js-events-toggle-all');
    const eventsAll = $('.js-events-all');

    if (slider.is('*')) {
        slider.slick({
            fade: true,
            infinite: false,
            prevArrow: $('.js-event-arrow-prev'),
            nextArrow: $('.js-event-arrow-next'),
            adaptiveHeight: true,
        });

        slider.on('click', '.js-events-toggle-all', function () {
            eventsAll.toggleClass('is-active');
            slider.slick('refresh');

            if (eventsAll.hasClass('is-active')) {
                toggleAll.text('Show Less');
            } else {
                toggleAll.text('Show All');
            }
        })
    }
}



// WEBPACK FOOTER //
// ../src/scripts/modules/events.js